import { render, staticRenderFns } from "./RmpAlerts.vue?vue&type=template&id=57c699de"
import script from "./RmpAlerts.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpAlerts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpAlerts.vue?vue&type=style&index=0&id=57c699de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports